import { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Box } from "@mui/system";
import {
  setSelectedAdgroups,
  setSelectedCampaigns,
  setSelectedRowsForNegatives,
} from "../../../../../../../../../../features/scopesTabSlice";
import FilterComponent from "../../../../../../../../../ReusableFIlterComponent/FilterComponent";

export default function NegativeFilterItems({ clearSelectedSearchTerm }: any) {
  const {
    negativesInListAndInAdGroupData,
    selectedCampaigns,
    selectedAdgroups,
  } = useSelector((state: any) => state.searchTermOperation);

  const dispatch = useDispatch();

  const [searchAdgroups, setSearchAdgroups] = useState("");
  const [searchCampaigns, setSearchCampaigns] = useState("");

  const filterConfig = [
    {
      key: "CampaignForNegativesInAdgroup",
      name: "Campaign",
      label: "Select one or more Campaigns",
      searchTerm: searchCampaigns,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchCampaigns(e.target.value),
      selectedOption: selectedCampaigns,
      filterName: "campaign_name",
      data: negativesInListAndInAdGroupData,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedCampaigns(updatedSelection)),
      count: selectedCampaigns && selectedCampaigns.length,
      colorSelected:
        selectedCampaigns !== null && selectedCampaigns.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "AdgroupsForNegativesInAdgroup",
      name: "Adgroup",
      label: "Select one or more Adgroups",
      searchTerm: searchAdgroups,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchAdgroups(e.target.value),
      selectedOption: selectedAdgroups,
      filterName: "adgroup_name",
      data: negativesInListAndInAdGroupData,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedAdgroups(updatedSelection)),
      count: selectedAdgroups && selectedAdgroups.length,
      colorSelected:
        selectedAdgroups !== null && selectedAdgroups.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
  ];

  const clearFilters = () => {
    dispatch(setSelectedCampaigns([]));
    dispatch(setSelectedAdgroups([]));
    clearSelectedSearchTerm(null);
    setSearchAdgroups("");
    setSearchCampaigns("");
    dispatch(setSelectedRowsForNegatives([]));
  };

  // const noFiltersSelected =
  //   (!selectedCampaigns || selectedCampaigns.length === 0) &&
  //   (!selectedAdgroups || selectedAdgroups.length === 0);

  return (
    <Box data-tracker="136" sx={{ position: "relative" }}>
      <FilterComponent
        filterConfig={filterConfig}
        clearFilters={clearFilters}
      />
      {/* {noFiltersSelected && (
       <Box
        sx={{
          position: "absolute",
          right: 0, // Adjust if button isn’t fully right-aligned
          top: 0,
          bottom: 0,
          width: "100px", // Width roughly covering the Clear Filter button
          pointerEvents: "auto",
          cursor: "default",
          backgroundColor: "transparent",
        }}
      />
       )} */}
    </Box>
  );
}
